module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.fdbc1302.jpeg";